// Header.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Menu } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';

import { NavLinks } from './NavLinks';
import { UserMenu } from '../../shared_components/UserMenu';
import { ModeToggle } from '../../shared_components/mode-toggle';

import logo from '@/assets/waterflai.svg';
import { DocsButton } from '../../shared_components/doc-button';
import { FeedbackButton } from '../../shared_components/feedback-button';
import { AdminMenu } from './AdminMenu'; // Import AdminMenu

const Header: React.FC = () => {
  const { t } = useTranslation();

  return (
    <header className="sticky top-0 flex h-16 items-center gap-4 border-b bg-background px-4 md:px-6 z-50">
      {/* Mobile Menu Trigger (no change) */}
      <Sheet>
        <SheetTrigger asChild>
          <Button variant="outline" size="icon" className="shrink-0 md:hidden">
            <Menu className="h-5 w-5" />
            <span className="sr-only">{t('header.toggleNavMenu')}</span>
          </Button>
        </SheetTrigger>
        <SheetContent side="left" className="flex flex-col">
          {/* Mobile Menu Content */}
          <nav className="grid gap-2 text-lg font-medium">
            {/* Logo in Sheet */}
            <Link to="/" className="flex items-center gap-2 text-lg font-semibold mb-4">
              <div className="w-32 h-6 relative">
                <img 
                  src={logo} 
                  alt="Waterflai logo" 
                  className="absolute top-0 left-0 w-full h-full object-contain dark:invert" 
                />
              </div>
              <span className="sr-only">Waterflai</span>
            </Link>
            {/* "Back to App" link for mobile */}
            <NavLinks isMobile />
            {/* Admin navigation links for mobile */}
            <AdminMenu isMobile /> 
          </nav>
        </SheetContent>
      </Sheet>

      {/* Main Logo (no change) */}
      <Link to="/" className="flex items-center gap-2 text-lg font-semibold">
      <div className="w-32 h-6 relative">
          <img 
            src={logo} 
            alt="Waterflai logo" 
            className="absolute top-0 left-0 w-full h-full object-contain dark:invert" 
          />
        </div>
        <span className="sr-only">Waterflai</span>
      </Link>

      {/* This div now pushes all items to the right,
        replacing the old centered navigation.
      */}
      <div className="flex flex-1 items-center justify-end gap-4">
        {/* Desktop "Back to App" button */}
        <nav className="hidden md:flex">
          <NavLinks />
        </nav>
        
        {/* Right-side icon group (no change) */}
        <div className="flex items-center gap-4 md:gap-2 lg:gap-4">
          <ModeToggle />
          <FeedbackButton />
          <DocsButton />
          <UserMenu />
        </div>
      </div>
    </header>
  );
};

export default Header;